// extracted by mini-css-extract-plugin
export default {"error":"error_error__HfJft","mainTxt":"error_mainTxt__Sc0Ry","subTxt":"error_subTxt__QJEIH","btnWrapper":"error_btnWrapper__+UXHM"};